<script setup lang="ts">
const props = defineProps<{
  rate: number
}>()

const {
  rate,
} = toRefs(props);

const starClass = (i) => {
  const roundedRate = Math.floor(rate.value); // Integer part of rate
  const fractionalRate = rate.value - roundedRate; // Fractional part of rate

  if (i <= rate.value) {
    return 'filled pe-n'; // Full star
  } else if (i - 1 < rate.value && fractionalRate >= 0.75) {
    return 'filled pe-n'; // Almost full star
  } else if (i - 1 < rate.value && fractionalRate >= 0.25) {
    return 'half-filled pe-n'; // Half star
  } else {
    return 'empty pe-n'; // Empty star
  }
};

// Computed function to determine the href for each star
const starHref = (i) => {
  const roundedRate = Math.floor(rate.value); // Integer part of rate
  const fractionalRate = rate.value - roundedRate; // Fractional part of rate

  if (i <= rate.value) {
    return '#star'; // Full star icon
  } else if (i - 1 < rate.value && fractionalRate >= 0.75) {
    return '#star'; // Almost full star icon
  } else if (i - 1 < rate.value && fractionalRate >= 0.25) {
    return '#star-half'; // Half star icon
  } else {
    return '#star'; // Empty star icon
  }
};
</script>

<template>
  <div class="cstars pe-n">
    <svg
        v-for="i in 5"
        :key="i"
        :class="['cicon', 'cstars__star', starClass(i)]"
    >
      <use :xlink:href="starHref(i)" />
    </svg>
  </div>
</template>
